import { Pressable } from 'react-native'
import Animated from 'react-native-reanimated'
import Svg from 'react-native-svg'

export default {
    Pressable: Animated.createAnimatedComponent(Pressable),
    Svg: Animated.createAnimatedComponent(Svg),
}
